module.exports = __webpack_public_path__ + "static/media/0000003.12575b57.JPG";